import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import PostListing from "../components/PostList"

const IndexPage = (props) => {
  const postEdges = props.data.allMdx.edges;

  return (
    <Layout>
      <SEO title="Home" />
      <PostListing postEdges={postEdges}/>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query IndexQuery {
    allMdx(limit: 1000, sort: {fields: [frontmatter___date], order: DESC}) {
      edges {
        node {
          excerpt
          frontmatter {
            slug
          }
          frontmatter {
            title
            date
            archive
          }
        }
      }
    }
  }
`;